import Fetch from "./fetch";
import axios from "axios";
import before from "./modules/before"; // 之前的接口api  分模块之前 2020/3/16
import doctor from "./modules/doctor"; // 疫情医护人员订票
import news from "./modules/news"; // 新闻
import common from "./modules/common"; // 公共接口
import vip from "./modules/vip"; // 会员
import activity from "./modules/activity"; // 活动
import user from "./modules/user"; // 用户
import babytk from "./modules/babytk"; // 婴儿票
import special from "./modules/special"; // 特殊旅客
import upgradeClass from "./modules/upgradeClass"; // 升舱
import mall from "./modules/mall";
import dragonPass from "./modules/dragonpass"; // 龙腾权益服务
import upgrades from "./modules/upgrades"; // 值机柜台升舱
import wrongFlightCertify from "./modules/wrongFlightCertify"; // 不正常航班证明
import luggage from "./modules/luggage"; // 不正常行李申报
import inovice from "./modules/inovice"; // 电子发票
import travelCard from "./modules/travelCard"; // 旅行卡
import city from "./modules/city" // 机场城市相关
import apply from "./modules/apply" // 申请类接口
import wxmp from "./modules/wxmp" // 微信小程序
export default {
  async fetch() {
    let fetch = new Fetch();
    return fetch.fetch(...arguments);
  },
  async fetchMall() {
    let fetch = new Fetch();
    return fetch.fetchMall(...arguments);
  },
  // 上传图片
  async uploadImg(file) {
    return new Promise((resolve, reject) => {
      let headers = {
        "Content-Type": "multipart/form-data"
      };
      let data = new FormData();
      data.append("filedata", file);
      axios({
        url: "/fdfs/upload",
        data: data,
        method: "POST",
        header: headers
      })
        .then(suc => {
          if (suc.data) {
            resolve(suc.data);
          } else {
            resolve(false);
          }
        })
        .catch(err => {
          reject(false);
        });
    });
  },
  // 新上传图片
  async uploadImage(file) {
    return new Promise((resolve, reject) => {
      let headers = {
        "Content-Type": "multipart/form-data"
      };
      let data = new FormData();
      data.append("filedata", file);
      axios({
        url: "/fdfs/imageupload",
        data: data,
        method: "POST",
        header: headers
      })
        .then(suc => {
          if (suc.data) {
            resolve(suc.data);
          } else {
            resolve(false);
          }
        })
        .catch(err => {
          reject(false);
        });
    });
  },
  ...before,
  ...doctor,
  ...news,
  ...common,
  ...vip,
  ...activity,
  ...user,
  ...babytk,
  ...special,
  ...upgradeClass,
  ...mall,
  ...dragonPass,
  ...upgrades,
  ...wrongFlightCertify,
  ...luggage,
  ...inovice,
  ...travelCard,
  ...city,
  ...apply,
  ...wxmp,
};



// WEBPACK FOOTER //
// ./src/interfaces/index.js